module.exports = __webpack_public_path__ + "img/bt.5217577f.svg";